import { NETWORK_DESCRIPTIONS } from "QuotePage/NetworkDescriptions";
import { NETWORK_SIZE_CONSTANTS } from "QuotePage/NetworkSizeConstants";

function networkTooltip(value) {
  switch (value) {
    case "HMO":
      return NETWORK_DESCRIPTIONS.HMO;

    case "HMP":
      return NETWORK_DESCRIPTIONS.HMP;

    case "PPO":
      return NETWORK_DESCRIPTIONS.PPO;

    case "EPO":
      return NETWORK_DESCRIPTIONS.EPO;

    case "POS":
      return NETWORK_DESCRIPTIONS.POS;

    case "Indemnity":
      return NETWORK_DESCRIPTIONS.Indemnity;

    case "multiple":
      return NETWORK_DESCRIPTIONS.multiple;

    default:
      return "";
  }
}

export function tooltip(heading, value) {
  switch (heading) {
    case "Plan Options":
      return "All the plans in this package will be offered to your employees.";

    case "Deductible":
      return "The insurance only kicks in after you have paid enough from your own pocket to meet the deductible.  Some procedures, like preventive care, waive the deductible, meaning that the insurance helps pay for the cost immediately. No matter what happens, you'll never have to pay more than the maximum yourself.";

    case "Doctor Visits":
      return "This is about how much you should expect to pay if you visit the doctor when you are sick. Annual check-ups are free. This takes into account the deductible and coinsurance rates.";

    case "Hospital":
      return "This is about how much you should expect to pay if you require a hospital stay for more than 1 day. This takes into account the deductible and coinsurance rates.";

    case "Network":
      return networkTooltip(value);

    case "Network Size":
      return NETWORK_SIZE_CONSTANTS[value] ? NETWORK_SIZE_CONSTANTS[value].tooltip : "";

    case "Generic Drugs":
      return "This is about how much you should expect to pay if you require an average generic prescription drug. This takes into account the deductible and coinsurance rates.";

    case "Cost Per Employee":
      return "This is the average cost per employee for your company based on the ages you've entered.  Individual prices will differ based on age.";

    case "Out-of-Pocket Max":
      return "The maximum cost you would be responsible for each year. No matter how expensive your treatments are, you will not pay more than this amount.";

    case "Re-sync Employees":
      return `Re-sync your employees from ${value}. Any updates from the sync will overwrite the list below`;

    default:
      return "";
  }
}
export function dentalTooltip(heading, value) {
  switch (heading) {
    case "Max Benefit":
      return "This is the total amount the dental insurance will pay out in a given year. Once you've received this amount in benefits, you will cover all costs for the rest of the year.";

    case "Cleanings":
      return "This is what you should expect to pay for a standard teeth cleaning.";

    case "Network":
      return networkTooltip(value);

    default:
      return "";
  }
}
export function visionTooltip(heading, value) {
  switch (heading) {
    case "Eye Exam":
      return "This is what you should expect to pay for a standard eye exam.";

    case "Frames":
      return "This is how much the insurance company will cover toward your eyeglass frames. Note that lenses will be an additional charge based on your plan.";

    case "Network":
      return networkTooltip(value);

    default:
      return "";
  }
}
